import React from 'react'
import NotificationAutoInterUpdator from '../../../../NotificationAutoInterUpdator'
import NotificationViewModel from '../../../../NotificationViewModel'
import i18next from 'i18next'

const DepContribRemovalNotif = (props) => {
  const { project } = props
  NotificationAutoInterUpdator(props)
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationViewModel
      {...props}
      learningSectionContent={''}
      notificationBody={
        <section style={{ width: '100%' }}>
          {rtl
            ? `لقد تم إزالتك من القسم الخاص بك`
            : 'You have been removed from your department'}
          {rtl ? `فى` : `in`} {project?.ProjectName}
        </section>
      }
      buttonsArray={[]}
    />
  )
}

export default DepContribRemovalNotif
